<div class="inline-flex items-center gap-1 px-2 py-0.5 rounded text-xs font-medium text-white" [ngClass]="{
  'bg-green-600': type === 'success',
  'bg-red-600': type === 'danger',
  'bg-yellow-600': type === 'warning',
  'bg-blue-600': type === 'info',
}">
  @if (icon) {
    <i class="h-4 w-4 me-3 text-base mr-1 border-white" [innerHTML]="icon | feather: { width: iconSize, height: iconSize }"></i>
  }
  <ng-content></ng-content>
</div>
